import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'commons/src/api/baseQuery';
import { LocationDetailsType } from 'commons/src/models/commonTypeScript';

export const locationApi = createApi({
    reducerPath: 'locationApi',
    baseQuery,
    tagTypes: ['LocationDetails', 'Locations'],
    endpoints: builder => ({
        updateLocationDetails: builder.mutation<void, LocationDetailsType>({
            query: location => ({
                url: `/locations/${location.id}`,
                method: 'PUT',
                data: location,
            }),
            invalidatesTags: ['LocationDetails'],
        }),
    }),
});

export const { useUpdateLocationDetailsMutation } = locationApi;
